import { ICardProps } from '@enter/core';
import React from 'react';
import * as S from './data-table-card.styles';

export const DataTableCard: React.FunctionComponent<ICardProps> = (props: ICardProps): React.ReactElement => {
    const { children, size = 'large' } = props;
    return (
        <S.DataTableCard size={size} loading={false} empty={false}>
            {children}
        </S.DataTableCard>
    );
};
